import i18n from '@/libs/i18n'

export default {
  GET_ALL_LIST_TABLE: state => state.all_overall_list_table,
  GET_ALL_CLIENTS_BY_INCOME: state => state.all_clients_by_income,
  GET_ALL_CLIENTS_TABLE: state => state.all_clients_table,
  GET_NOT_SOLD_FLAT: state => state.not_sold_flat,
  GET_SOLD_FLAT: state => state.sold_flat,
  GET_OVERALL_TABLE: state => state.overall_table,
  GET_OBJECTS: state => state.objects,
  GET_OBJECTS_COUNT: state => state.objects.count,
  GET_ONE_OBJECT({ single_object }) {
    const {
      object_type,
      latitude,
      longitude,
      region,
      rayon,
      parking,
      infrastructure,
      currency,
      payment_type,
      installment_end_date,
      ...rest
    } = single_object
    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)
    return {
      object_type: object_type?.id,
      position: {
        lat: latitude,
        lng: longitude,
      },
      currency: currency?.id,
      region: region?.parent?.id,
      rayon: region?.id,
      parking: parking.map(el => el.id),
      infrastructure: infrastructure?.map(el => el.id),
      payment_type: payment_type.map(el => el.id),
      installment_end_date: installment_end_date || tomorrow,
      ...rest,
    }
  },
  GET_OBJECT_MAIN_INFO({ single_object }) {
    const {
      title,
      bank,
      currency,
      infrastructure,
      site,
      object_type,
    } = single_object
    return {
      title,
      object_type: object_type?.name[i18n.locale],
      bank: bank && bank.bank_name,
      currency: currency?.title[i18n.locale],
      site,
      infrastructure: infrastructure?.map(el => el.title[i18n.locale]),
    }
  },
  GET_OBJECT_TYPES: state => state.object_types.results,
  GET_OBJECT_MEDIA(state) {
    const { title, links, video } = state.single_object
    return {
      title,
      links,
      video,
    }
  },
  GET_OBJECT_INFRASTRUCTURES(state) {
    return state.object_infrastuctures.results
  },
  GET_PARKING_OPTIONS(state) {
    return state.parking_options.results
  },
  GET_OBJECT_CALCULATIONS(state) {
    return state.object_calculations
  },
  GET_CONSTRUCTION_PROGRESS(state) {
    return state.construction_progress
  },
  GET_PRICE_HISTORY(state) {
    return state.price_history
  },
  GET_DISCOUNT_HISTORY(state) {
    return state.discount_history
  },
  GET_PAYMENT_TYPES(state) {
    return state.payment_types.results
  },
  GET_ONE_PAYMENT_TYPE(state) {
    return state.single_payment_type
  },
  GET_REPORTS_TABLE(state) {
    return state.reports
  },
  GET_RELATED_PERSON(state) {
    return state.relatedPerson
  },
}
